<div class="wrapper container-fluid">
  <h4>Emotional Analysis</h4>
  <div class="card">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start">
      <mat-tab label="Agent">
        <div class="chart_row row m-0">
          <div class="chart_column col-8">
            <div class="details_row row">
              <h4 class="details_column col"><span class="details_title">Name: </span>Ravi raj</h4>
              <h4 class="details_column col"><span class="details_title">Gender: </span>Male</h4>
              <h4 class="details_column col"><span class="details_title">Age: </span>25yrs</h4>
            </div>
            <canvas class="chart pb-5" baseChart [datasets]="emotionAnalysisdataSets" [labels]="emotionAnalysislables"
              [legend]="emotionAnalysislegend" [options]="emotionAnalysisoptions" [type]="'line'">
            </canvas>
          </div>
          <div class="chart_column col-4">
            <ul class="emotions card">
              <li class="emotion card-header" *ngFor="let emotion of emotions; let i= index">
                <span class="emotion_type">
                  <img class="emotion_icon" [src]="emotion.imgUrl" alt="icon">
                  <h6 class="emotion_name">{{ emotion.name }}</h6>
                </span>
                <h1 class="emotion_value" [ngStyle]="{color: i | color }">{{ emotion.per }}%</h1>
              </li>
            </ul>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Customer">
        <div class="chart_row row m-0">
          <div class="chart_column col-8">
            <div class="details_row row">
              <h4 class="details_column col"><span class="details_title">Name: </span>Ravi raj</h4>
              <h4 class="details_column col"><span class="details_title">Gender: </span>Male</h4>
              <h4 class="details_column col"><span class="details_title">Age: </span>25yrs</h4>
            </div>
            <canvas class="chart" baseChart [datasets]="emotionAnalysisdataSets" [labels]="emotionAnalysislables"
              [legend]="emotionAnalysislegend" [options]="emotionAnalysisoptions" [type]="'line'">
            </canvas>
          </div>
          <div class="chart_column col-4">
            <ul class="emotions card">
              <li class="emotion card-header" *ngFor="let emotion of emotions; let i = index">
                <span class="emotion_type">
                  <img class="emotion_icon" [src]="emotion.imgUrl" alt="icon">
                  <h6 class="emotion_name">{{ emotion.name }}</h6>
                </span>
                <h1 class="emotion_value" [ngStyle]="{color: i | color }">{{ emotion.per }}%</h1>
              </li>
            </ul>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
  <div class="chart_row row px-0">
    <div class="chart_column col">
      <div class="card">
        <div class="card-header">
          <h4>Overall Emotion Detected</h4>
        </div>
        <div class="card-body">
          <canvas baseChart [type]="'pie'" [datasets]="emotionDetectedDatasets" [labels]="emotionDetectedLabels"
            [options]="emotionDetectedOptions" [plugins]="emotionDetectedPlugins" [legend]="emotionDetectedLegend">
          </canvas>
        </div>
      </div>
    </div>
    <div class="chart_column col">
      <div class="card">
        <div class="card-header">
          <h4>Overall Emotional Engagement</h4>
        </div>
        <div class="card-body">
          <canvas baseChart [type]="'pie'" [datasets]="emotionEngagementDatasets" [labels]="emotionEngagementLabels"
            [options]="emotionEngagementOptions" [plugins]="emotionEngagementPlugins"
            [legend]="emotionEngagementLegend">
          </canvas>
        </div>
      </div>
    </div>
    <div class="chart_column col">
      <div class="card">
        <div class="card-header">
          <h4>Participants by Gender</h4>
        </div>
        <div class="card-body">
          <canvas baseChart [type]="'pie'" [datasets]="particularGenderDatasets" [labels]="particularGenderLabels"
            [options]="particularGenderOptions" [plugins]="particularGenderPlugins" [legend]="particularGenderLegend">
          </canvas>
        </div>
      </div>
    </div>
  </div>
</div>
